import React from "react";
import PackageBookingComponent from "@components/PackageBooking";

export default function PackageBooking() {
  return <PackageBookingComponent />;
}
